import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { FileRecord } from "@/shared/domain/files";

interface RenameFileProps {
  fileId: string;
  datasetId: string;
  currentPath: string;
  newName: string;
}

export function useRenameFile() {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FileRecord, Error, RenameFileProps>({
    mutationFn: ({ fileId, datasetId, currentPath, newName }) => {
      return fileService.renameFile(fileId, datasetId, currentPath, newName);
    },
    onSuccess: (file) => {
      queryClient.setQueryData(["fileRecord", file.file_id], file);
      return queryClient.invalidateQueries({ queryKey: ["directoryContents"] });
    },
  });
}
